import { axiosClient } from "services/axios";

export function getClients(clientgroupid?: string) {
  return axiosClient
    .get("users/clients", { params: { clientgroupid: clientgroupid || null } })
    .then((res) => res.data);
}

export function deleteClient(clientid: string) {
  return axiosClient.post("users/delete-client", { clientid });
}
